import { render, staticRenderFns } from "./PurchaseDuoStructure.vue?vue&type=template&id=20035204&"
import script from "./PurchaseDuoStructure.vue?vue&type=script&lang=js&"
export * from "./PurchaseDuoStructure.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports